import {
  MutationStatus,
  UseMutateAsyncFunction,
  useMutation
} from 'react-query';

import { getAPIErrorMessage } from '@nw/shared/utils';

import { getUserProfileDetailGraphQlQuery } from '../../../graphQL/NiatApplicationPortal/querys/getUserProfileQuery';
import {
  GetUserProfileDetailGraphQlRequestObjectType,
  QueryGraphQlResponseType
} from '../../../services/IbUserAccountsServices/GraphQlService/types';
import { networkCallWithGraphQL } from '../../../utils/AuthAPIUtils';

import { useAccountsRefreshAuthTokens } from '../../useAccountsRefreshAuthTokens';

import { useIbUserAccountsGraphQLService } from '../useIbUserAccountsGraphQLService';

interface UseGetUserProfileDetailGraphQLInterface {
  getUserProfileDetailGraphQLApi: UseMutateAsyncFunction<
    QueryGraphQlResponseType,
    Error,
    GetUserProfileDetailGraphQlRequestObjectType
  >;
  error: string | null;
  status: MutationStatus;
}

const useGetUserProfileDetailGraphQL =
  (): UseGetUserProfileDetailGraphQLInterface => {
    const { ibUserAccountsGraphQLService } = useIbUserAccountsGraphQLService();
    const { refreshTokenApi, getRefreshToken } = useAccountsRefreshAuthTokens();
    const getUserProfileDetailGraphQL = (
      requestObject: GetUserProfileDetailGraphQlRequestObjectType
    ) => {
      const { keysToGetInSuccessResponse, accessToken } = requestObject;

      const query = getUserProfileDetailGraphQlQuery(
        keysToGetInSuccessResponse
      );
      if (accessToken) {
        return ibUserAccountsGraphQLService.ibUserAccountsGraphQlQuery(
          query,
          networkCallWithGraphQL(
            refreshTokenApi,
            () => accessToken,
            getRefreshToken
          )
        );
      } else
        return ibUserAccountsGraphQLService.ibUserAccountsGraphQlQuery(query);
    };

    const { mutateAsync, error, status } = useMutation(
      getUserProfileDetailGraphQL,
      {
        mutationKey: ['getUserProfileDetailGraphQLApi']
      }
    );

    return {
      getUserProfileDetailGraphQLApi: mutateAsync,
      error: error ? getAPIErrorMessage(error) : null,
      status
    };
  };

export { useGetUserProfileDetailGraphQL };
